const initialState = {};

function reducer(state = initialState, action) {
    switch (action.type) {
        case "city":
            return Object.assign({}, state, action.data);

        default:
            return state;
    }
}

const data = {
    name: "city",
    reducer: reducer,
};

export default data;